import React from "react";

const shimmerBase: React.CSSProperties = {
  background: "linear-gradient(90deg, #f0f0f0 25%, #e8e8e8 50%, #f0f0f0 75%)",
  backgroundSize: "1200px 100%",
  animation: "ps-shimmer 1.6s ease-in-out infinite",
  borderRadius: 6,
};

const keyframes = `
@keyframes ps-shimmer {
  0%   { background-position: -600px 0; }
  100% { background-position: 600px 0; }
}
`;

const Box: React.FC<React.CSSProperties> = (props) => <div style={{ ...shimmerBase, ...props }} />;

const Row: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div style={{ display: "flex", gap: "1rem", marginBottom: "1rem" }}>{children}</div>
);

const CardSkeleton: React.FC = () => (
  <div style={{ flex: 1, minWidth: 0, borderRadius: 10, overflow: "hidden", border: "1px solid #eee" }}>
    <Box height={160} borderRadius={0} />
    <div style={{ padding: "1rem", display: "flex", flexDirection: "column", gap: 10 }}>
      <Box height={16} width="85%" />
      <Box height={14} width="100%" />
      <Box height={14} width="55%" />
      <Box height={14} width="40%" />
    </div>
  </div>
);

export const PageSkeleton: React.FC<{ variant?: "default" | "detail" | "cards" }> = ({ variant = "default" }) => {
  const tag = <style>{keyframes}</style>;

  if (variant === "detail") {
    return (
      <div style={{ width: "100%", padding: "2rem 1.5rem", boxSizing: "border-box" }}>
        {tag}
        <Box height={28} width={260} marginBottom="0.75rem" />
        <Box height={16} width={180} marginBottom="2rem" />
        <div style={{ display: "flex", gap: "2rem", flexWrap: "wrap", marginTop: "1rem" }}>
          <Box width={140} height={140} borderRadius="50%" flexShrink={0} />
          <div style={{ flex: 1, minWidth: 240 }}>
            <Box height={28} width="70%" marginBottom="1rem" />
            <Box height={14} width="100%" marginBottom="0.5rem" />
            <Box height={14} width="100%" marginBottom="0.5rem" />
            <Box height={14} width="45%" marginBottom="1rem" />
            <Box height={44} width={180} borderRadius={8} />
          </div>
        </div>
      </div>
    );
  }

  if (variant === "cards") {
    return (
      <div style={{ width: "100%", padding: "2rem 1.5rem", boxSizing: "border-box" }}>
        {tag}
        <Box height={28} width={260} marginBottom="0.75rem" />
        <Box height={16} width={180} marginBottom="2rem" />
        <Row><CardSkeleton /><CardSkeleton /><CardSkeleton /></Row>
        <Row><CardSkeleton /><CardSkeleton /><CardSkeleton /></Row>
      </div>
    );
  }

  return (
    <div style={{ width: "100%", padding: "2rem 1.5rem", boxSizing: "border-box" }}>
      {tag}
      <Box height={28} width={260} marginBottom="0.75rem" />
      <Box height={16} width={180} marginBottom="2rem" />
      <div style={{ display: "flex", gap: "2rem", flexWrap: "wrap" }}>
        <div style={{ flex: 1 }}>
          <Box height={14} width="100%" marginBottom="0.625rem" />
          <Box height={14} width="100%" marginBottom="0.625rem" />
          <Box height={14} width="80%" marginBottom="0.625rem" />
          <Box height={14} width="60%" marginBottom="1.5rem" />
          <Box height={44} width={160} borderRadius={8} />
        </div>
        <Box width={240} height={180} borderRadius={10} flexShrink={0} />
      </div>
    </div>
  );
};
